import { styled } from 'linaria/react';

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: var(--space-200);
`;

export const EmptyStateIconWrapper = styled.div`
  margin-bottom: var(--space-200);
`;

export const EmptyStateText = styled.div`
  text-align: center;
`;
